import { ReactComponent as DropdownIcon } from './icn_dropdown.svg';

const NextArrow = () =><DropdownIcon style={{width: '30px', height: '30px', transform: 'rotate(-90deg)', cursor:'pointer'}}/>;

export default NextArrow;